/** @format */

import React, { FC, useEffect, useState } from 'react'
import { _$, Tab, Tabs } from '@king-design/react'
import styled from 'styled-components'
import { MonitorCrumb } from 'src/components'
import { useHistory, useLocation, useParams } from 'react-router'
import InstanceInfoTab from 'src/containers/PrometheusMonitor/Instance/Info'
import InstanceRecordTab from 'src/containers/PrometheusMonitor/Instance/Record'
import { useAsyncFn } from 'react-use'
import { getPromethuesInstance } from 'src/api/ApiPromethuesInstance'
function useQuery() {
  return new URLSearchParams(useLocation().search)
}
const PrometheusInstance: FC<{ className?: string }> = ({ className }) => {
  const { clusterId } = useParams<{ clusterId: string }>()
  const history = useHistory()
  const query = useQuery()
  const initTab = query.get('tab') || 'info'
  const [tab, setTb] = useState<string>(initTab)

  // 获取资源
  const [{ value: instanceInfo }, getInstanceInfo] = useAsyncFn(async () => {
    if (clusterId && localStorage.systemId) {
      const result = await getPromethuesInstance({
        SearchRegion: localStorage.systemId,
        ClusterId: clusterId
      })
      return result?.InstancesSet?.[0] || {}
    } else {
      return {}
    }
  }, [clusterId])

  useEffect(() => {
    getInstanceInfo()
  }, [tab])

  return (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: _$('Prometheus监控') },
          { title: _$('实例列表'), route: '/monitor/prometheusmonitor/instanceList' },
          { title: instanceInfo?.ClusterName || '' }
        ]}
      />
      <Tabs
        type="card"
        value={tab}
        onChangeValue={tab => {
          history.push(`/monitor/prometheusmonitor/instanceList/view/${clusterId}?tab=${tab}`)
          setTb(tab)
        }}
      >
        <Tab value="info">{_$('实例信息')}</Tab>
        <Tab value="record">{_$('预聚合')}</Tab>
      </Tabs>
      <div className="tab_content">
        {tab === 'info' ? <InstanceInfoTab instanceInfo={instanceInfo} /> : null}
        {tab === 'record' ? (
          <InstanceRecordTab tab={tab} instanceID={instanceInfo?.ControllerID} />
        ) : null}
      </div>
    </div>
  )
}

export default styled(PrometheusInstance)`
  padding: 0 16px;
`
